import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "card-slot" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "slot-opening-border" }, null, -1 /* HOISTED */)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "slot-opening" }, null, -1 /* HOISTED */)
const _hoisted_4 = { class: "card-3d-container" }
const _hoisted_5 = { class: "card-3d" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "bottom-shadow" }, null, -1 /* HOISTED */)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "overlay-shadow" }, null, -1 /* HOISTED */)
const _hoisted_8 = { class: "inner-border" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "difficulty-label" }, "DIFFICULTY LEVEL", -1 /* HOISTED */)
const _hoisted_10 = { class: "difficulty-text" }
const _hoisted_11 = {
  key: 0,
  width: "26",
  height: "27",
  viewBox: "0 0 26 27",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M7.06146 26.0683H9.46624V23.5066C9.46624 22.6179 11.0869 22.4611 11.0869 23.5066V26.0683H14.2758V23.5066C14.2758 22.3565 15.8964 22.5657 15.8964 23.5066V26.0683H18.3535C19.8173 26.0683 20.6928 24.7125 20.6537 23.8726V20.4745C22.3789 19.3767 25.2542 16.3969 25.411 11.6918C25.5678 6.98683 20.8105 0.504359 12.6029 0.608915C4.39528 0.713471 -0.152903 6.62088 0.00392541 12.0055C0.136392 16.5537 3.15804 19.3941 4.76123 20.4745V23.8726C4.76123 24.9181 5.91134 26.0683 7.06146 26.0683ZM11.1391 13.3648C11.1391 15.1548 9.68798 16.606 7.89789 16.606C6.10781 16.606 4.65666 15.1548 4.65666 13.3648C4.65666 11.5747 6.10781 10.1235 7.89789 10.1235C9.68798 10.1235 11.1391 11.5747 11.1391 13.3648ZM17.4125 16.606C19.2026 16.606 20.6537 15.1548 20.6537 13.3648C20.6537 11.5747 19.2026 10.1235 17.4125 10.1235C15.6224 10.1235 14.1713 11.5747 14.1713 13.3648C14.1713 15.1548 15.6224 16.606 17.4125 16.606Z",
  fill: "black"
}, null, -1 /* HOISTED */)
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = {
  key: 1,
  width: "26",
  height: "26",
  viewBox: "0 0 26 26",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M26 11.5673C26 15.1874 24.1311 18.2147 21.2049 20.1585V23.6653H21.2026C21.1469 24.9641 20.0719 26 18.7541 26H7.35246C5.99891 26 4.90164 24.9072 4.90164 23.5592V20.2285C1.91436 18.2878 0 15.2312 0 11.5673C0 5.17887 5.82029 0 13 0C20.1797 0 26 5.17887 26 11.5673ZM7.35246 23.5592H9.80328V22.1796C9.80328 20.7469 12.2541 20.6408 12.2541 22.1796V23.5592H13.8525V22.233C13.8525 20.8004 16.3033 20.6942 16.3033 22.233V23.5592H18.7541V20.0041C18.7541 19.4735 19.0596 18.3281 19.7939 17.9036C22.1433 16.3056 23.6557 13.9772 23.6557 11.5673C23.6557 6.52691 18.885 2.44082 13 2.44082C7.11499 2.44082 2.34426 6.52691 2.34426 11.5673C2.34426 13.9772 3.75863 16.3056 6.02049 17.9036C7.03358 18.7987 7.35246 19.3143 7.35246 20.0041V23.5592ZM11.6148 13.0531C11.6148 14.6941 10.2789 16.0245 8.63115 16.0245C6.98335 16.0245 5.64754 14.6941 5.64754 13.0531C5.64754 11.412 6.98335 10.0816 8.63115 10.0816C10.2789 10.0816 11.6148 11.412 11.6148 13.0531ZM20.459 13.0531C20.459 14.6941 19.1232 16.0245 17.4754 16.0245C15.8276 16.0245 14.4918 14.6941 14.4918 13.0531C14.4918 11.412 15.8276 10.0816 17.4754 10.0816C19.1232 10.0816 20.459 11.412 20.459 13.0531Z",
  fill: "black"
}, null, -1 /* HOISTED */)
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "serial-number-label" }, "SERIAL NUMBER", -1 /* HOISTED */)
const _hoisted_18 = { class: "serial-number-text" }

import gameModes from "@src/config/gameModes";
import { PropType } from "vue";
import { DifficultyLevel } from "@src/helpers/difficultyLevelConstants";


export default /*#__PURE__*/_defineComponent({
  __name: 'CardReader',
  props: {
  serialNumber: {
    type: String,
    default: null,
  },
  difficulty: {
    type: Number as PropType<DifficultyLevel>,
    default: () => DifficultyLevel.EASY,
  },
},
  setup(__props) {

const props = __props;



function isDifficultyStarSelected(difficulty: DifficultyLevel): boolean {
  return difficulty <= props.difficulty;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(gameModes), (v, i) => {
              return (_openBlock(), _createElementBlock(_Fragment, null, [
                (isDifficultyStarSelected(v.difficulty))
                  ? (_openBlock(), _createElementBlock("svg", _hoisted_11, _hoisted_13))
                  : (_openBlock(), _createElementBlock("svg", _hoisted_14, _hoisted_16))
              ], 64 /* STABLE_FRAGMENT */))
            }), 256 /* UNKEYED_FRAGMENT */))
          ]),
          _hoisted_17,
          _createElementVNode("div", _hoisted_18, _toDisplayString(__props.serialNumber || "??-????"), 1 /* TEXT */)
        ])
      ])
    ])
  ]))
}
}

})